import { GraphQLClient } from 'graphql-request'

export const client = new GraphQLClient(`https://${window.storefront.domain}/api/${window.storefront.apiVersion}/graphql.json`, {
  headers: {
     'X-Shopify-Storefront-Access-Token': window.storefront.apiKey
   }
});
